import { Children, cloneElement, isValidElement } from 'react';

import { AvatarGroup as StyledAvatarGroup } from './AvatarGroup.styled';
import { Props } from './types';

export const AvatarGroup = ({ size = 56, children, ...props }: Props) => (
  <StyledAvatarGroup {...props} size={size}>
    {Children.map(Children.toArray(children), (child) =>
      isValidElement(child) ? cloneElement(child, { size }) : child,
    )}
  </StyledAvatarGroup>
);

export default AvatarGroup;
